import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceLeft2.vue?vue&type=template&id=e6cf33aa&"
import script from "./FaceDirectionResultEffectFaceLeft2.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceLeft2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports